const isArrayWithContent = (object, minlength = 1) => Array.isArray(object) && object.length >= minlength;

export default {
    isArrayWithContent
};
